import React from "react";

import { translate } from "application/functions";

import Tick from "assets/img/tick.png";

const FinalStep = (props) => {
  const { dataPaypal, startAgain } = props;
  return (
    <div className="form__form-body-title">
      <div className="thanks-container">
        <div className="thanks-tick-container">
          <img src={Tick} alt="tick" />
        </div>
        <div className="thanks-title">
          {translate("thanks")}, {dataPaypal[1]}!
        </div>
        <div className="thanks-number">
          {translate("request.number")}: {dataPaypal[0]}
        </div>
        <div className="thanks-subtitle">{translate("thanks.droppoint.title")}</div>
        <div className="thanks-subtitle-text">{translate("thanks.droppoint.message")}</div>
        <div className="thanks-subtitle">{translate("thanks.delivery.title")}</div>
        <div className="thanks-subtitle-text">{translate("thanks.delivery.message")}</div>
        <div className="form__form-back-fix"></div>
        <div className="form__button-back-container">
          <button className="form__button-component" onClick={() => startAgain()}>
            {translate("final.ok")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinalStep;
